import React, { useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchLegalAgreementStatus } from "../../services/userManagementService";
import { acceptAgreement } from "../../store/auth";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { notifier } from "@tintelligence/components";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const user = useSelector((state) => state.auth.user.userName);
  const userRole = useSelector((state) => state.auth.user.role);
  const userCompany = useSelector((state) => state.auth.user.companyName);
  const [agreementAccepted, setAgreementAccepted] = React.useState(null);
  const [agreementStatusChecked, setAgreementStatusChecked] = React.useState(false);
  const hasCheckedAgreement = React.useRef(false);
  const hasShownNotification = React.useRef(false);
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  if (location.search.includes("sso=1")) location.search = "";
  const byPassLogin = localStorage.getItem("byPassLogin");
  const dispatch = useDispatch();

  const isAdmin = userRole?.includes('Admin') && !userRole?.includes('SuperAdmin');
  const isSuperAdmin = userRole?.includes('SuperAdmin');

  const fetchAgrreementStatus = async () => {
    try {
      const data = await fetchLegalAgreementStatus(userCompany);
      if (data.showLegalAgreement == true && isAdmin) {
        localStorage.setItem('legalAgreement', 'false');
        setAgreementAccepted(false);
        setAgreementStatusChecked(true);
      } else if (data.showLegalAgreement == true && !isAdmin && isSuperAdmin) {
        notifier.warn("Legal agreement acceptance pending. SuperAdmin users can access the application");
        setAgreementAccepted(true);
        setAgreementStatusChecked(true);
        history.replace("/main/shops");
      } else if (data.showLegalAgreement == true && !isAdmin && !isSuperAdmin) {
        notifier.warn("You must accept the legal agreement to access the application. You will be redirected to the login page.");
        setAgreementAccepted(false);
        setAgreementStatusChecked(true);
        history.replace("/logout");
      }
      if (data.showLegalAgreement == false) { // false means agreement is accepted
        localStorage.setItem('legalAgreement', 'true');
        setAgreementAccepted(true);
        setAgreementStatusChecked(true);
      }
    } catch (e) {
      console.log("Error fetching agreement status:", e);
    }
  }

  useEffect(() => {
    if (sessionStorage.getItem('declinedAgreement') === 'true') {
      // setAgreementStatusChecked(true);
      history.replace("/logout");
    } else if (agreementAccepted === null && user) {
      fetchAgrreementStatus();
    }
  }, [agreementAccepted, user]);

  if (!user && !byPassLogin) {
    return (
      <Route>
        <Redirect
          to={{
            pathname: "/login",
            state: { from: location },
          }}
        />
      </Route>
    );
  }

  if (user && agreementStatusChecked) {
    if (isAdmin && !isSuperAdmin && !agreementAccepted) {
      return (
        <Route>
          <Redirect to={{ pathname: "/agreement" }} />
        </Route>
      );
    }

    if (!isAdmin && !agreementAccepted) {
      return (
        <Route>
          <Component {...rest} />
        </Route>
      )
    }

    return (
      <Route>
        <Component {...rest} />
      </Route>
    );
  } else if (agreementStatusChecked == false && sessionStorage.getItem('declinedAgreement') == 'true') {
    return (
      <Route>
        <Component {...rest} />
      </Route>
    );
  } else return null; // or a loading spinner while checking agreement status
};

export default ProtectedRoute;